<h1 mat-dialog-title *ngIf="title">
    <span>{{ title }}</span>
    <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
</h1>
<mat-dialog-content>
    <h4 [innerHTML]="message"></h4>
    <p [innerHTML]="submessage"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="basic" (click)="CancelHandler()">{{ canceltext }}</button>
    <button mat-raised-button color="warn" (click)="OKHandler()" [disabled]="disableDelete">
        <span *ngIf="disableDelete">{{ data.DelayDelete }}</span>
        {{ oktext }}</button>
</mat-dialog-actions>
